var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"content-item content-item-article",class:_vm.classes,attrs:{"href":_vm.urlArticle,"id":_vm.contentItem.contentItemId},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"status-badge-small mr-1",style:(_vm.stylesArticle)}),_c('span',{staticClass:"ellipsis-nowrap"},[_vm._v(_vm._s(_vm.contentItem.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }